/** The publication states offered as chips, `All` being no filter. */
export enum CasePublication {
  All = 'all',
  Published = 'published',
  Unpublished = 'unpublished',
}
